import { ref, reactive } from 'vue';
import moment from 'moment';

const initialState = () => {
    return {
        races: reactive([]),
        selectedRunners: reactive({}),
        selectedRace: ref(),
        raceToModify: ref({}),
        showRunnerSelection: ref(false),
    };
};

const state = initialState();

const actions = {
    resetPlayState({ commit }) {
        commit('resetState');
    },
};

const mutations = {
    setGameState(state, races) {
        Object.assign(state.races, races);

        let raceId = 1;

        races.some((race, index) => {
            if (
                (index + 1 === raceId && race.results.length) ||
                (index + 1 && !moment(race.starts_at).subtract(2, 'minutes').isAfter(moment()))
            ) {
                raceId++;
            }
        });

        let invalidKey = races[raceId] === undefined;

        if (invalidKey) {
            raceId = 0;
        }

        state.selectedRace = state.selectedRace === undefined ? raceId : state.selectedRace;
    },

    updateSelectedRunners(state, runner) {
        Object.assign(state.selectedRunners, { [runner.race.id]: runner });

        // state.selectedRace = state.races[state.selectedRace] !== undefined ? state.selectedRace + 1 : 0;
    },

    updateSelectedRace(state, raceId) {
        state.selectedRace = raceId;
    },

    switchRunner(state, { key, runner }) {
        state.selectedRunners.splice(key, 1);

        state.selectedRace = runner.race.number;
    },

    removeRunner(state, key) {
        delete state.selectedRunners[key];
    },

    removeSelectedRunners(state, meeting) {
        meeting.races.forEach((race) => {
            delete state.selectedRunners[race.id];
        });
    },

    setRaceToModify(state, race) {
        if (race !== undefined) {
            state.raceToModify = race;
        } else {
            state.raceToModify = undefined;
        }
    },

    toggleShowRunnerSelection(state) {
        state.showRunnerSelection = !state.showRunnerSelection;
    },

    resetState(state) {
        Object.assign(state, initialState());
    },
};

const getters = {
    races(state) {
        return state.races;
    },

    selectedRunners(state) {
        return state.selectedRunners;
    },

    selectedRace(state) {
        return state.selectedRace;
    },

    raceToModify(state) {
        return state.raceToModify;
    },
};

export default {
    state,
    actions,
    mutations,
    getters,
};
